import { SVGProps } from "react";

const Unassigned = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={36} height={36} rx={6} fill="#E8E8E8" />
    <circle cx={18} cy={12.25} r={5.25} fill="currentColor" />
    <path
      d="M23.6409 29C25.9103 29 27.8225 27.1 27.0078 24.9818C26.5178 23.7079 25.7997 22.5504 24.8943 21.5754C23.9889 20.6004 22.9141 19.8269 21.7312 19.2993C20.5482 18.7716 19.2804 18.5 18 18.5C16.7196 18.5 15.4518 18.7716 14.2688 19.2993C13.0859 19.8269 12.0111 20.6004 11.1057 21.5754C10.2003 22.5504 9.48216 23.7079 8.99217 24.9818C8.17748 27.1 10.0897 29 12.3591 29L18 29L23.6409 29Z"
      fill="currentColor"
    />
  </svg>
);
export default Unassigned;
